import * as React from 'react'
import Seo from '../../components/seo'

import Footer from '../../sections/footer'

import Form from './components/form'

export default function Consultant() {
  return (
    <>
      <Seo
        description="Nya Dooer är inte bara personliga seniora ekonomer och senaste AI-tekniken. Vi är mycket mer. Läs mer om allt du får när du väljer Dooer för din bokföring."
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Dooer konsultindex | Dooer"
        url="https://www.dooer.com/partner"
      />

      <Form />

      <Footer inverted />
    </>
  )
}
